/*
 * Created Date: 22-01-2024, 4:51:41 pm
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified: Mon Jan 22 2024
 * Modified By: Victor
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import { useEffect, useState } from 'react'
// import Proptypes from 'prop-types'

const useStorage = props => {
	const { key, initValue, store } = props
	const storage = store === 'local' ? localStorage : sessionStorage

	const [state, setState] = useState(() => {
		const initLocalValue = storage.getItem(key)
		if (initLocalValue) {
			return JSON.parse(initLocalValue)
		}
		return initValue
	})

	useEffect(() => {
		storage.setItem(key, JSON.stringify(state))
	}, [JSON.stringify(state)])

	return [state, setState]
}

export default useStorage
